import Glide from '@glidejs/glide';

import './style.scss';

const initSamplesSlider = () => {
  const samplesBlock = document.querySelector('[data-slider="samples"]');
  if (!samplesBlock) return;

  const glide = new Glide('[data-slider="samples"]', {
    perView: 4,
    gap: 24,
    type: 'carousel',
    startAt: '0',
    breakpoints: {
      1199: {
        perView: 3,
      },
      768: {
        perView: 1,
      },
    },
  });

  const samplesCarts = Array.prototype.slice.call(samplesBlock.querySelectorAll('.card'));

  samplesCarts.forEach((order, key) => {
    const bullet = document.createElement('button');
    bullet.classList.add('glide__bullet');
    bullet.setAttribute('data-glide-dir', `=${key}`);
    document.querySelector('[data-bullets="samples"]').appendChild(bullet);
  });

  glide.mount();
};

document.addEventListener('DOMContentLoaded', () => {
  if (document.readyState === 'complete') {
    initSamplesSlider();
  } else {
    window.addEventListener('load', initSamplesSlider);
  }
});
